var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-category-header"},[_c('div',{staticClass:"s-16 w-600 uppercase prefix"},[_vm._t("prefix")],2),_c('div',{staticClass:"title font-palantino"},[_vm._t("title")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }